module.exports = __webpack_public_path__ + "img/neo-spinner.5cfe242b.svg";